<template>
  <section class="credit-usage-section">
    <CreditUsageSummaryCard
      :data="data"
      :is-loading="isLoading"
      :error="error"
      @retry="retry"
      @see-usage="router.push('/billing/mcp-usage')"
    />
  </section>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import { useSharedCreditUsage } from '@/composables/credits/useCreditUsage';
import { enableMocks } from '@/mocks';
import { registerCreditUsageMock } from '@/mocks/creditUsage';

import CreditUsageSummaryCard from './CreditUsageSummaryCard.vue';

if (enableMocks) registerCreditUsageMock();

const router = useRouter();

const { data, isLoading, error, retry } = useSharedCreditUsage();
</script>
